<template>
  <div class="one index">
    <div ref="header"><Header :bg="bg"></Header></div>
    <div class="toubu">
      <div class="text">
        汉康新闻中心
        <div class="bottom">
          专注于智慧城市,智慧水务等领域,记录行业内外最新资讯
        </div>
      </div>
    </div>

    <!-- <div class="nav-box" ref="navbox">
      <div class="nav" ref="nav">
        <div class="nav-son" v-for="(item, index) in nav" :key="index">
          {{ item.name }}
        </div>
      </div>
    </div> -->
    <div class="box">
      <div
        class="son"
        v-for="(item, index) in arr"
        :key="index"
        @click="more(item)"
      >
        <img class="img" :src="item.src" alt="" />
        <div class="title">
          <span>公司新闻 丨</span
          >{{
            item.title.length > 22
              ? item.title.slice(0, 20) + " . . ."
              : item.title
          }}
        </div>
        <div
          class="text"
          v-html="
            item.text.length >= 46
              ? item.text.slice(0, 44) + ' . . .'
              : item.text
          "
        ></div>
        <!-- <div class="time">
          {{ item.time }} <span>{{ item.yers }}</span>
        </div> -->
        <em>
          <div class="line"></div>
        </em>
        <!-- <div class="jiantou">></div> -->
      </div>
      <div class="gengduo_box">
        <div
          class="gengduo"
          v-for="item in btn"
          :key="item.name"
          v-show="btnShow == item.show"
          @click="active"
        >
          {{ item.name }}
          <span :class="item.class"></span>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../../../components/Header.vue";
import Footer from "../../../components/Footer.vue";
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      list: [
        {
          src: require("../../../assets/imgs/xinwen/23.png"),
          title: "中标资讯： 成都汉康中标龙泉国家级经济开发区智慧水务项目",
          text: "水是生命之源，水是健康之首，是城市发展的基础性自然资源和战略性经济资源，本项目是利用物联网、大数据、云计算、GIS、SCADA等技术，构建大成都首个智慧饮水安全大数据管理平台，实现从水源地、水厂到水龙头供水全过程生产运行的数据采集、存储、运行情况可视化展示、调度分析决策、业务过程管理、异常检测预警及运行能效分析和智能报表管理等内容,为全面提升调度管理水平，形成城市供水管控一体化提供坚强支撑。做到“全人群、全方位、全周期”推动饮用水污染防治防疫管理。是贯彻《健康中国－优水计划》规划的首个落地案例，“管水到楼、优水入户”基本实现，居民饮水安全信息得到全面公示。本项目建设模式即将在全国范围内快速推广。<br><br>",
          time: "08-03",
          yers: "2020",
          imgs: [{ src: require("../../../assets/imgs/xinwen/23.png") }],
        },
        {
          src: require("../../../assets/imgs/xinwen/22.png"),
          title:
            "中标资讯：热烈祝贺成都汉康中标国家电网浙江运变电站三维数据服务项目",
          text: "本项目基于三维数据切片标准化服务软件开发，完成运变电站三维数据切片标准化服务的提升工作，包括完善设备及地物三维模型数据解析、组织优化、三维模型数据切片、标准服务功能。实现统一的三维模型数据切片标准化服务，降低三维数据与三维平台的耦合度，达到三维数据及功能服务的资源共享。<br><br>",
          time: "08-06",
          yers: "2020",
          imgs: [{ src: require("../../../assets/imgs/xinwen/22.png") }],
        },
        {
          src: require("../../../assets/imgs/xinwen/21.png"),
          title:
            "中标资讯：热烈祝贺成都汉康中标国家电网特高压换流站三维全景管控系统项目",
          text: "本项目主要基于GIS+BIM技术开发±1100kV特高压换流站三维全景管控系统，实现全站和单体设备状态、环境状态和消防状态三维动态可视，并结合相关物联感知设备的实时监测数据，构建国家电网特高压换流站数字孪生系统，通过专题视图的形式对设备状态、火情隐患进行实时演示及监控。<br>三维全景管控系统作为指挥平台与可视化驾驶舱，是站端物联网系统的大脑中枢，实现换流站全景超现实可视、实现换流站主辅设备及运行环境的智能化三维分析及场景仿真可视、实现火情及消防设施智能化虚拟现实及模拟推演，确保应用效果最大化。<br>",
          time: "08-07",
          yers: "2020",
          imgs: [
            { src: require("../../../assets/imgs/xinwen/21.png") },
            { src: require("../../../assets/imgs/xinwen/21-1.png") },
          ],
        },
        {
          src: require("../../../assets/imgs/xinwen/20-1.png"),
          title: "数字经济时代下的新型智慧城市建设",
          text: " 2019年，我国数字经济规模不断扩张、贡献不断增强，全年增加值规模达到35.8万亿元，占GDP比重达到36.2%。数字经济框架从“三化”扩展到“四化”：数字产业化、产业数字化、数字化治理、数据价值化。面对突如其来的新冠肺炎疫情，我国数字经济展现出强大的抗冲击能力和发展韧性，众多领域成为数字新技术的“试验场”、新模式的“练兵场”、新业态的“培育场”。线上线下加速融合，赋能疫情防控、促消费稳增长、助复工促生产、惠民生保稳定、优服务强治理。<br><br> “新型智慧城市”的三个“新”<br>“新型智慧城市”相较“智慧城市”而言，主要体现在三个“新”，一是新的战略重心——构建一套适应城市特色、行之有效的管理制度体系；二是新的思维理念——从通过上设备、做系统，解决城市单一或局部的表象问题，到通过合理规划数据流，串联城市运行的方方面面，进而从根本上解决城市问题；三是新的攻关方向——从城市视角出发，以数据驱动为核心，系统性解决城市复杂性问题，提升市民获得感。传统意义上的智慧城市大多侧重技术层面，即基础网络、感知设备、云计算设施、共性平台及基础信息资源等。而新型智慧城市则指通过体系规划、信息主导、推进新一代信息技术与城市现代化深度融合和迭代演进，从而实现治理更现代、运行更智慧、发展更安全、人民更幸福。新型智慧城市本质是提升政府、社会治理体系和治理能力，更好地为人民服务。随着各类信息基础设施建设的不断完善，智慧城市理念不断走向成熟，大数据、云计算、物联网、移动互联网、人工智能等新兴的ICT技术迅猛发展，仅仅关注城市各部门的信息化建设显然不足以满足城市未来长远、可持续发展的需求，而传统智慧城市建设所造成的“信息烟囱”“数据孤岛”“重技术轻应用”等问题也逐渐暴露，由此，从智慧城市向新型智慧城市演进可以说是必然趋势。城市的发展最终是为“人”服务，根本上是促进人在城市中更好地生活和发展。因此，新型智慧城市也从过去以“信息技术”为出发点，回到“人”这一最根本的出发点和落脚点，“以人为本”将成为新型智慧城市的重要特征。<br><br>新型智慧城市建设要注意的几个问题<br>新型智慧城市的建设是一个长期演进的过程，是不断用数据和人工智能反哺和赋能城市的过程，是建筑学、规划学、教育学、人类学等多种学科数据打通的过程，是为了让城市运转效率不断提高，居民可以把更多时间空间留给生活的过程。新型智慧城市是个综合概念，重点是管理与服务、政府主导、全社会参与。从规划建设开始一定要注意几个方面：第一瞄得要准，要做真需求、真问题和真痛点；第二想得要大，新型智慧城市是一个大系统的工程，是一个面向复杂系统开展顶层设计的规划；第三起步要小，对于拿不准的，用小项目、原型系统起步、允许试错；第四扩展要快，有了顶层设计还要小步快跑，要不断迭代和逼近，快速更新和强力拓展；第五动力要足，迫切需要通过实践真正找准适合新型智慧城市的政府和实行社会合作的机制。<br>党的十九大报告指出，创新是引领发展的第一动力，是建设现代化经济体系的战略支撑。新型智慧城市建设是构建数字中国、智慧社会的重要内容，也是建设创新型国家的重要着力点。我们认为建设新型智慧城市，需要注意几个方面。一是坚持顶层设计。智慧城市是一个要素复杂、应用多样、相互作用、不断演化的综合性复杂巨系统，要坚持技术实施和制度政策两个层面并重开展顶层设计。二是坚持创新驱动。新型智慧城市的发展无论是管理的体制、运行的机制还是技术的实现方式都是在创新中完成的，只有构建创新生态，促进大众创新、开放创新、协同创新，推动管理机制创新、运营模式创新、资本运作创新，才能发挥新型智慧城市建设的示范引领作用，把周边的城市、城镇、农村都带动起来，互动发展、联动发展、统筹发展。三是坚持以人为本。智慧城市最终要服务于人，要把更多的精力放在满足每一个城乡居民的需求上，注重城市功能的提升，包括面向人的生活、教育、经济、环境等城市能力的增长，善于找到最大的公约数，找到百姓的刚性需求，集中发力，重点突破。四是坚持智慧并进。新型智慧城市提出建设一个开放的体系架构、一张天地一体的栅格网、一个通用功能平台、一个开放共享的数据体系、一个高效运营的管理中心、一套统一的标准体系，可以促进智与慧融为一体，改变智而不慧的窘境，破解“城市病”难题。五是坚持措施落地。在具体实施过程中，加强顶层设计，注重规划衔接。实现统一领导、统一管理，实现资源整合，解决“信息孤岛”，对基础设施进行智能化提升，培育相适应的产业结构和产业体系，探索建立“政府引导、市场主导、多元主体、全球参与”的新型建设模式。<br>对于智慧城市建设而言，顶层设计是灵魂，是引导其走向成功的“明灯”。它不仅仅从宏观层面给出了智慧城市建设的方向，同时也可以回答“智慧城市如何产出”“政府建设完智慧城市又要怎么发展”等关键又复杂的问题。构建智慧城市顶层设计，关键问题是要明确建设智慧城市的核心是在建城市，“智慧”只是城市的加分项。因此，只有面向城市的真正需要，智慧城市才有生命力；只有基于对现阶段真形势、真问题和真任务的有效剖析、理解和陈述，同时对未来的一切加以筹谋，才能避免智慧城市顶层设计在实践过程中执行力度大打折扣等问题。因此，未来各大城市在完善智慧城市顶层设计的过程中需要注意：在汲取国际优秀经验的同时，加快面向城市真问题的基础性创新，引导信息化行业有效地服务于城市需求，而不是城市去适应技术和产能，尽快形成能够回应城市真问题、运营模式可行的系统解决方案。同时加快从智慧城市来到智慧城市去的思维，用新兴技术、策略，来帮助城市做好情景反演，从而服务于智慧应用的选择。<br>“新基建”助推智慧城市建设<br>近年来我国数字经济快速发展，以互联网、大数据、云计算、人工智能、区块链、物联网等为代表的新一代数字科技与实体经济日趋融合。在抗击疫情的背景下，我国正将疫情冲击转化为经济转型动力，培育壮大数字经济新动能，加快撬动“新基建”引擎，激发新经济潜能。微观的模式创新、中观的产业更迭、宏观的整体推进，“新基建”快车已然启动，智能时代来临必须先打好“新基建”的基础地基，其技术链条第一步就是收集数据；第二步是计算分析数据，由此云计算领域应运而生；第三步是大数据+云计算产生人工智能模块，同时这里又涉及大量数据的传输和巨大算力的电力损耗，5G基建和特高压就成为核心；第四步AI应用的核心终端。目前的共识有两点：一是智能汽车，二是智能穿戴设备，它们的主要功能是实时采集人与环境的数据，同时实时反馈给出智能化决策。第五步智能汽车在环保的大背景下必然是发展新能源汽车，“单机版”的智能驾驶在万物互联后，成为“全局版”的智慧交通。第六步智慧交通作为城市大脑的最重要核心之一，会与智慧安防、智慧医疗等各类公共服务组成智慧城市的核心模块。“新基建”意味着新机遇、新担当、新使命、新动能、新引擎，聚焦“新网络、新要素、新生态、新平台、新应用、新安全”，网络基础稳固、数据智能融合、产业生态完善、平台创新活跃、应用智慧丰富、安全可信可控的新型基础设施，将对提高城市科技创新活力、经济发展质量、公共服务水平、社会治理能力形成强有力支撑。<br>总之，对于新型智慧城市建设来说，有四个层次需要递进：首先，“万物互联”是基础，信息基础设施加快向超高速升级换代，光纤宽带成为主流接入方式。在信息通信技术的持续演进下，泛在、高速连接使得网络获得更加多样化、网络应用更加多元化，进入人、机、物“万物互联”新时代。其次，海量数据是关键，全球化发展正从国际金融驱动为特征的2.0版本步入以数据要素为主要驱动力的3.0版本，数据作为新生产要素的重要作用日益凸显，数据的开放、共享和应用将进一步优化资源配置和使用效率，提高资源、资本、人才全要素生产率。再次，人工智能是引擎，人工智能将重构生产、分配、交换、消费等经济活动各环节，形成从宏观到微观各领域的智能化新需求，进而引发链式突破，推动社会生产和消费从工业化向自动化、智能化转变，极大提高行业服务精准化、便利化水平，全面提升人民生活品质，提升社会运行的稳定度。最后，融合创新是目标，随着新一代信息技术的持续演进和全面创新，驱动农业、工业和服务业数字化转型升级，引发各领域、各行业的业务形态变革和产业结构调整，推动与医疗、教育、养老、居住等各领域的深度融合，为人们提供多层次、全覆盖、人性化的公共服务，营造宜居宜业的和谐环境，满足人们对美好生活的需要。<br>值得关注的是，近年来，我国新业态、新领域如雨后春笋般快速发展，此次新冠肺炎疫情就让我们认识到了信息技术深度融合与数字化转型所带来的巨大效益。从学习到办公，从医疗到教育，从娱乐到消费，每个人都能在这段特殊时期感受到网络创新的便利、技术变革的红利。互联网、物联网、云计算、大数据、人工智能、区块链、新基建等一系列的技术与城市发展相融合，通过互联互通，跨层级、跨地域、跨系统、跨部门、跨业务进行协同管理和服务，让城市管理、服务模式、产业布局、消费供需更加合理，更加透明高效，随着5G商用加速推进、AI等数字技术进入大规模应用阶段、治理方式也发生着深刻变化，涉及民生领域的建设成为当下推动政府治理体系和治理能力现代化的着力点和突破口。<br><br>反思智慧城市的发展，应该认识到，发展智慧城市必须把握两个核心：一个核心是城市本身。不论是什么样的智慧城市，都是以技术手段改进来服务于整个城市系统，智慧城市的发展应该注重系统性，而不只是城市局面的高科技改造。另一个核心则是人。城市的发展应该以人为本，智慧城市建设也不能偏离这个核心。如果忽视了人的需要，建设智慧城市就会变成“暴力式”的技术应用过程。真正的“智慧”不仅是技术上的更新换代，也并非只是效率的提升，更为重要的是“以人为本”的实现，即在新型智慧城市建设中，无论哪个方向都应该时刻追问“是否抵达人本”的特点。因此必须通过更加合理化、人性化的商业模式创新设计，以人的诉求为出发点，以人的需求为突破点，才能真正实现让物质围绕着人进行，才能真正实现一个万物互联的、智慧化的时代。未来的智慧社会除了信息网络泛在化、规划管理信息化、基础设施智能化、公共服务普惠化、社会治理精细化、产业发展数字化、政府决策科学化等，将更侧重多中心的创新系统驱动，生产、生活、治理、服务将更有机地形成为一个整体，在政府提供智慧平台、标准的基础上，由企业、机构、居民共同打造智慧政府、智慧企业、智慧城市、智慧生活。",
          time: "12-16",
          yers: "2020",
          imgs: [
            // { src: require("../../../assets/imgs/xinwen/20.png") },
            { src: require("../../../assets/imgs/xinwen/20-1.png") },
          ],
        },
        {
          src: require("../../../assets/imgs/xinwen/19.png"),
          title: "中标资讯：热烈祝贺成都汉康中标省级智慧高速公路项目",
          text: "热烈祝贺汉康信息中标智慧高速公路四川省级视频云联网工程项目。<br>省级云平台部署在云端的 VPC（Virtual Private Cloud，虚拟私有云）里，构建出一个隔离的、自行管理配置策略的虚拟网络环境，保证数据资源的安全性，在 VPC 环境中管理私有的子网结构、IP 地址范围和分配方式、 网络的路由策略等，形成可控的私有的云计算环境。实现云联网要求，包括省级云平台的视频管理、分发、网络安全及接口技术要求等。（1）提供省级视频云监管监控平台，满足对全省交通行业上云视频的管理，实现视频资源全面共享。（2）支持应用端的联调（包括但不限于微信公众号、安卓/IOS APP、浏览器等），支持全省高速公路监控视频通过云端进行调看、地图展示等功能。（3）随着全省交通行业上云视频的数量不断增加，根据相关部门要求和技术发展所需，各单位及公众等对调看视频的需求的不断增长，为满足一系列的需求，省级云平台应具备扩容能力。（4）省级云平台应具备与部级云平台无缝对接能力，使得通过部级云平台具有调看省域范围内视频准实时播放能力。<br><br>",
          time: "08-03",
          yers: "2021",
          imgs: [{ src: require("../../../assets/imgs/xinwen/19.png") }],
        },
        {
          src: require("../../../assets/imgs/xinwen/18.png"),
          title: "中标资讯：热烈祝贺成都汉康中标智慧联网报警项目",
          text: "热烈祝贺成都汉康中标中融安保集团联网报警升级改造信息化工程项目本项目主要是建设中融安保集团运营指挥中心，充分利用了现代化音视频技术、数字化技术、计算机多媒体技术、网络技术、智能控制技术等。遵循“数字网络化、智能化、统一管理化、系统兼容、安全可靠、先进实用”的总原则。以监控、管理为手段，以控制、优化为目的，从统筹、指挥、管理的角度出发，根据指挥决策者的实际需要，整合重点数据信息，快速、精准地在指挥中心大屏幕上调用、显示，真正实现辅助决策、业务智能，提升中融安保集团管理效率和服务管理质量。<br><br>中融安保集团有限责任公司（原成都市保安服务总公司，简称“中融安保集团”）是于1987年由成都市公安局组建成立，现隶属于成都交子金融控股集团有限公司的市属国资大型安保服务企业，系中国保安协会常务理事单位、中国保安协会人力防范专业委员会主任委员单位。成立30余年以来，中融安保集团始终秉承“从管理提质量、从质量取信誉、从信誉赢客户”的经营理念，内强素质、外塑形象，长期维护客户安全、辅助公安机关预防和打击犯罪活动，逐步发展为规模宏大、实力雄厚、服务高效的西南第 一、全国一 流综合性安保服务供应商。",
          time: "08-04",
          yers: "2021",
          imgs: [{ src: require("../../../assets/imgs/xinwen/18.png") }],
        },
        {
          src: require("../../../assets/imgs/xinwen/17.png"),
          title: "中标资讯：热烈祝贺成都汉康中标智慧防汛指挥中心项目",
          text: "热烈祝贺成都汉康中标成都市水务局防汛指挥中心改建项目。<br>近年，成都市水务局积极践行习近平总书记新时期治水方针，紧紧围绕成渝地区双城经济圈建设、成德眉资同城化发展和建设践行新发展理念的公园城市示范区等中央、省市重大决策部署，抢抓发展机遇，主动开拓创新，着力推动“六水攻坚”，积极构建“六网统筹”，努力推动管水治水能力再上新台阶。在水安全保障方面，以提升灾害防御能力为重点，着力以科技赋能构建智慧防汛指挥体系，通过强化水情、雨情、汛情、灾情数据信息的归集和资源整合，打通数据交换共享通道等手段，有序推进数据汇集、重点提示、社情收集、民意检索、全域感知、自动预报、智能预警、智慧调度、河湖公报、新闻发布等系统建设，构建多灾种综合预警平台，赋能智慧防汛，建设新一代的成都市防汛指挥中心。<br><br>通过本项目建设，满足“平战结合”等多种业务模式显示需求，可以进行日常城市、区域监控协调与调度，实时了解、掌握城市水务日常运行情况、安全监督，及时发现问题，及时处理解决问题，杜绝隐患，提升指挥中心调度综合管理能力，实现应急处置过程中应急决策、现场信息、处置指挥的全程可视化和各种资源的融合调度，提高突发洪水及重大水利事件的预防和处置能力，增强各级领导集中管理、统一指挥应对各种突发事故的应急处置能力。",
          time: "08-05",
          yers: "2021",
          imgs: [{ src: require("../../../assets/imgs/xinwen/17.png") }],
        },
        {
          src: require("../../../assets/imgs/xinwen/16.png"),
          title: "中标资讯：热烈祝贺成都汉康中标山洪灾害防治运维项目",
          text: "热烈祝贺成都汉康中标内蒙古山洪灾害防治监测站点运行维护项目。本项目主要针对内蒙古自治区山洪灾害防治非工程措施项目自动监测站点包括自动雨量站、自动水位站、自动视频/图像监控站、墒情监测站及监测信息传输等运行维护。运行维护内容：传感器单元、传输单元、供电单元、防雷系统、基础设施等设施、设备加电运行、看护、除尘，设备运行状况观察、接口测试，硬件安装、测试、设置，硬件升级，备份数据文件，电池等零部件更换、故障处理修复等。确保旗县监测站点数据准确并实时传回旗县本级和自治区水文总局。<br><br>",
          time: "08-06",
          yers: "2021",
          imgs: [{ src: require("../../../assets/imgs/xinwen/16.png") }],
        },
        {
          src: require("../../../assets/imgs/xinwen/15.png"),
          title: "中标资讯：热烈祝贺成都汉康中标数字孪生河道项目",
          text: "热烈祝贺成都汉康中标成都市锦江绿道BIM信息系统开发项目。城市水务管理是城市生存、发展基础，与城市的社会经济发展息息相关。锦江绿道BIM信息系统的建设，是“智慧成都”建设的需要，是成都市“智慧水务”的重要载体之一，通过信息化建设，不断提升城市水务的综合管理水平和综合竞争力。<br><br>在建设智慧城市、智慧水务的大背景下，结合府河治理现状，充分利用汉康GIS+BIM、物联网、云计算、大数据和VR技术构建一体化、可扩展的锦江绿道BIM信息系统。实现府河26公里模型全覆盖，河道治理、生态监测数据信息可视化管理，河道重要景观，通过漫游和借助专业输入设备查看VR实景，全方位的孪生整个锦江26公里绿道，让用户感受绿道真实魅力。通过本项目的建设，实现数据共享，增强对府河治理的监管能力，提高府河水务治理水平，实现城市水务智慧运作，成都智慧水务体系将更加完善，管理水平将更加科学高效和智能。<br><br>",
          time: "08-24",
          yers: "2021",
          imgs: [
            { src: require("../../../assets/imgs/xinwen/15.png") },
            { src: require("../../../assets/imgs/xinwen/15-1.png") },
          ],
        },
        {
          src: require("../../../assets/imgs/xinwen/14.png"),
          title: "喜讯：成都汉康连中四标",
          text: "热烈祝贺成都汉康连续中标四个智慧水务项目：<br>一、成都市金牛区一体化智慧水务决策指挥系统项目；<br>二、成都市青羊区一体化智慧水务决策指挥系统项目；<br>三、盐边县高堰沟灌区智能信息化建设项目；<br>四、成都市城市桥梁水位监测系统建设项目。<br><br>成都汉康持续在智慧水务领域发力，深入研究水务大数据，利用人工智能、大数据、区块链等技术，真正做到赋能城市水务治理，在“水”服务方面，让百姓有美好的获得感，让管理者在管理方面有新的突破。<br><br>成都汉康信息产业有限公司，始创于2001年成都汉康信息产业有限公司，总部坐落在美丽的“天府之国”成都高新技术产业区。从ICT行业起步，经过20年的发展，现已成为ICT领域多元化投资控股公司，致力于成为中国领先的智慧城市、智慧水务、大数据、区块链、健康管理、产业园等投资、建设、运营于一体的高新技术企业集团。在全国拥有分子公司超过10家，目前在成都、北京、上海、安徽、武汉、南京、贵阳设有独立控股公司和研究院。高度重视并充分发挥人才的作用，发现并培养领军人物，为员工创造事业舞台，激发企业的发展活力。",
          time: "12-03",
          yers: "2021",
          imgs: [{ src: require("../../../assets/imgs/xinwen/14.png") }],
        },
        {
          src: require("../../../assets/imgs/xinwen/13.png"),
          title: "重磅：汉康智能感知终端助力智慧水务、智慧蓉城建设！",
          text: "成都汉康自研的埋入式液位探测仪智能感知终端，成功部署成都大运会场馆周边低洼积水处，对汛期低洼积水安全隐患，提供实时在线监测预警，可提前通知城市内涝防汛人员做防汛预案，为场馆赛事人员安全进出，提供科学安全出行保障。<br><br>低洼积水感知数据部署在成都汉康承建成都中心城区暴雨内涝预报预警系统上，补充智慧防汛外场感知源，实现“一汛统筹”，为后续强化城市内涝信息的实时智能监测分析，构建“预报、预警、预演、预案”体系，实现“大运会”场馆防汛保障和城区防汛工作的“全量信息汇集”、“实时立体感知”、“精准预报预警”、“高效智能调度”、“智能场景再现”提供有效的前端感知数据支撑，强化感知能力建设，增强人民群众获得感、幸福感、安全感。<br><br>低洼积水监测智能终端介绍<br><br>工作机制：<br>通过积水探测器超声波接口监测地面积水深度，并通过内置LORA通信方式上报智能网关，智能网关发送云服务器，为用户指挥决策提供数据支持，提升城市水文监测能力。同时可通过LoRa通信方式传送至附近智能网关进行现场预警指示。<br><br>主要功能：<br><br>水位采集<br>有积水时，根据设置的采集周期定时采集水位<br><br>数据传输<br>通过LORA进行数据发送<br><br>积水探测<br>智能传感器检测积水状态，没积水不采集<br><br>智能采集频度<br>多个采集频度自动控制，水位越高采集越频繁<br><br>数据自动补发<br>保障数据的完整性<br><br>数据存储<br>可保存积水数据，掉电数据不丢失<br><br>远程配置<br>运行参数远程配置<br><br>休眠模式<br>支持低功耗休眠工作模式<br><br>支持与平台联动，当水位到达阈值，可发出声光报警<br><br>",
          time: "06-18",
          yers: "2022",
          imgs: [
            { src: require("../../../assets/imgs/xinwen/13.png") },
            { src: require("../../../assets/imgs/xinwen/13-1.png") },
            { src: require("../../../assets/imgs/xinwen/13-2.png") },
            { src: require("../../../assets/imgs/xinwen/13-3.png") },
          ],
        },
        {
          src: require("../../../assets/imgs/xinwen/12-1.png"),
          title: "《成都市“十四五”新型智慧城市建设规划》正式印发",
          text: "中国共产党成都市第十四次代表大会提出，今后五年，成都将积极探索超大城市现代化治理新路径，提升城市智慧治理水平。要坚持以“智慧蓉城”建设为牵引，全面推动城市经济、生活、治理数字化转型，让城市运转更聪明、更智慧。蓝图已经绘就，具体怎么干？近日，成都市政务服务管理和网络理政办公室正式印发《成都市“十四五”新型智慧城市建设规划》（以下简称《规划》），系统谋划了未来五年，成都建设智慧城市的发展路径。</br></br>总体目标</br></br>《规划》明确，到2025年，基本实现数字基础设施集约共享、智慧蓉城运行中枢高效运转，公共管理、公共服务、公共安全领域智慧化水平大幅提升，数字经济与智慧蓉城建设深度融合发展，安全支撑牢固可靠，超大城市敏捷治理、科学治理水平大幅提升，人民群众的获得感、幸福感、安全感显著增强。</br></br>8大方面、28项指标  系统构建“十四五”期间成都新型智慧城市建设目标体系</br></br>《规划》对标相关规划，立足成都实际，从基础设施、运行中枢、三大重点领域应用场景（公共管理、公共服务、公共安全）、数字经济、协同保障、安全支撑八个方面，采取“定性目标+定量指标”方式，经过专题研讨、意见征求和科学测算后，提出28项指标，系统构建“十四五”期间成都市新型智慧城市建设目标体系。</br></br>“1133”总体架构</br></br>根据《规划》，智慧蓉城建设总体架构为：一个数字基座，即聚焦城市智能基础设施、数据资源体系、数字使能平台，打造一体化、智能化、集约化的城市数字基座。一个智慧蓉城运行中枢，即组建智慧蓉城运行中心，搭建三级智慧蓉城运行管理平台，提升城市体征监测预警水平，增强事件处置指挥调度能力。三大重点智慧应用领域，即围绕公共管理、公共服务、公共安全三大重点领域，推进智慧化应用场景建设。三大支撑体系，一是双向赋能支撑体系，即构建数字经济与智慧蓉城建设深度融合、双向赋能的发展格局，助力数字经济发展；二是全域安全支撑体系，即围绕安全保障机制、网络安全保障、数据安全防护和安全技术创新，构建全域网络和数据安全支撑体系；三是协同保障支撑体系，即建立完善区域协同、组织管理、法制保障、运营运维保障支撑体系。</br></br>夯实城市数字基础设施  构筑集约共享新基座</br></br>根据《规划》，“十四五”期间，成都将聚焦建强城市智能基础设施、建强城市数据资源体系、建强城市数字使能平台等3大任务，建设高速泛在、天地一体、云网融合、智能敏捷、绿色低碳、安全可控的智能化综合性数字信息基础设施，为智慧蓉城建设提供有力支撑。<br><br>建强城市智能基础设施，“十四五”期间，成都将完善智能感知、网络传输及存算融合基础设施。包括：推动地上、地下基础设施智能化，统筹推进物联感知和视频感知源在市政设施、交通运输、建筑工地、地下管网、河湖管理、公园绿道、生态环境、地质灾害、安全应急、治安防控、气象监测等领域部署，提升泛在感知、终端联网、智能调度能力，构建天空地一体化感知体系；加快建设5G、高速光纤宽带，实现双千兆全市覆盖，推进跨行业信息通信基础设施共建共享、互联互通；推进国家“东数西算”工程实施，推动成都人工智能大数据中心发展；加快全国一体化算力网络成渝国家枢纽节点建设，全力打造天府数据中心集群。<br><br>建强城市数据资源体系，“十四五”期间，成都将在数据资源汇聚共享、数据资源治理提质、数据资源开放应用等方面发力。包括：建设完善“城市数据大脑”，打造市、区（市）县统筹的大数据资源平台体系，推动城市数据资源实时、全样、巨量汇聚共享，实现数据横向协同、纵向赋能，增强城市整体运行管理、决策辅助、应急处置能力；构建良性循环、动态更新的整体化数据治理体系，探索对数据战略、组织机构、制度标准、业务管理、技术手段、专业队伍等实现有机整合；完善全市统一的公共数据开放平台，探索建立政务数据开放“负面清单”制度，重点推动企业信用、产品质量、食品药品安全、综合交通、公用设施、环境质量等相关领域的数据向社会安全有序开放，鼓励市政公用企事业单位、公共服务事业单位等机构将教育、医疗、就业、旅游、生活等信息资源向社会开放。<br><br>建强城市数字使能平台，“十四五”期间，成都将完善并依托智慧空间信息平台，统筹地理信息、遥感影像、实景三维等时空基础数据，构建全市统一地名地址库和“一标多实”数据库，推进全域覆盖、“人、房、户、地、事、物、情”多维数据时空关联融合，增强二三维一体化空间地理信息服务能力。同时，以打造数字孪生城市为目标，建设城市信息模型（CIM）平台，支持向下分级部署，按管理场景需求构建决策支持、模拟仿真、态势推演等二三维可视化模型，支撑城市最小空间单元运行情况的精准研判，实现资源调度的最快速度、最短路径、最优配备。<br><br>建设智慧蓉城运行中枢  构建整体智治新模式<br><br>《规划》提出，“十四五”期间，成都将围绕建立智慧蓉城运行管理架构、提升城市体征监测预警水平、提升事件处置指挥调度水平等3大任务，加强态势实时感知、风险监测预警、资源统筹调度、线上线下协同等能力建设，促进城市运行“一网统管”，实现“一云汇数据、一屏观全域、一网管全城、一体防风险”。根据《规划》，“十四五”期间，成都将构建智慧蓉城运行中心三级体系，即聚焦城市运行“一网统管”和事件高效敏捷处置，依托现有城市运行管理基础，组建面向统筹指挥的市级智慧蓉城运行中心、面向实战枢纽的区（市）县智慧蓉城运行中心、面向联勤联动的镇（街道）智慧蓉城运行中心，构建“主动发现、快速响应、扁平指挥、高效联动、敏捷处置”的城市运行管理体系，为应对城市运行风险、强化城市运行韧性、提升城市智慧治理和服务能力提供关键支撑。同时，采用统分结合模式，统筹建设市、区（市）县、镇（街道）三级智慧蓉城运行管理平台，市级统一建设运行管理平台、城市运行数字体征体系、市域物联感知体系、数据资源体系、“城市一张图”和标准规范体系。值得一提的是，成都还将建设“8+N”智慧应用场景体系，即打造智慧大运、疫情防控、交通管理、应急管理、智慧公安、生态环保、水务管理、智慧社区八大领域智慧应用场景，统一接入城市运行管理三级平台，横向打通各领域系统，纵向贯通各层级数据，推动城市运行事件分级分类协同和线上线下联动，在最低层级、最早时间，以相对最小成本，解决最突出问题。围绕公共管理、公共服务、公共安全运行监测要求，以文化旅游、消费、养老、教育、体育、农业农村、智慧气象、充电桩、城市建设和管理、企业诉求感知、市民诉求感知等为重点，持续打造N个智慧应用场景，拓展构建或整合优化一批管用好用爱用会用的智慧应用场景，对接城市运行管理三级平台，提升城市精细化管理水平。<br><br>打造重点领域应用场景  塑造智慧蓉城新形象<br><br>根据《规划》，“十四五”期间，成都将以智慧应用为主线，以数据共享为支撑，以共建共享为保障，推动公共管理、公共服务、公共安全3大领域智慧化，助力智慧韧性安全城市建设工程落地落实。推进公共管理智慧化，“十四五”期间，成都将在经济管理智慧化、市场监管智慧化、社会管理智慧化、生态环保智慧化等领域发力。包括：构建“产业生态圈和产业链图谱”，强化重大项目管理，对全市重点产业链构成、协同发展程度和产业链集聚效应等进行跟踪分析、监督检查、量化评估；探索“移动执法”“非现场执法”等智慧执法，建立市场监管综合行政执法智慧平台，推动包容审慎、智能智慧、分类分级监管，提高监管执法数字化、规范化和透明度，着力实现市场监管“无事不扰、无处不在”；升级“大联动·微治理”平台，推进全科网格建设，实现对网格内“人、地、事、物、情”的全天候、实时化、动态化管理和服务。成都还将大力推动智慧社区建设，编制智慧社区建设规划，发布智慧社区建设导则，汇聚时空地理、电子证照、人流物流等数据，构筑社区一体化“数字底座”，搭建智慧社区综合信息平台，围绕社区安全、社区治理、社区服务、社区发展、社区党建五大板块营建各类应用场景，打造数字“孪生”社区，发展数字家庭。推进公共服务智慧化，“十四五”期间，成都将在政务服务“一网通办”、惠企政策“一网直达”、政府信息“一网公开”、社会诉求“一键回应”、深化民生服务“在线可及”等领域发力。包括：以“天府蓉易办”平台为面向企业办事、服务的总入口，提供企业从开办到注销的全生命周期服务体系，推动“全程网办”“一网通办”“全域通办”，实现“办事不求人、办成事不找人”。同时，整合各类涉企政策申报事项，推动跨层级、跨部门、跨区域流程再造，实现政策申报“一套材料、一张表格、一键申请、一网通办”。以“天府市民云”为面向市民生活服务的总入口，面向市民全生命周期服务需求，持续优化服务流程，推动服务能力和服务资源整合，强化各类数据和人工智能（AI）能力应用提升，打造数字化社区便民服务中心。融合市政府门户网站、市县乡各级政府负责人网络信箱、12345热线、移动客户端等多种渠道，完善全市统一网络理政社会诉求平台，建立完善成德眉资区域12345热线联动机制。此外，成都还将推进公共安全智慧化，强化重大疫情防控全流程、全环节、全主体闭环管理，打造集数据监测、研判分析、指挥调度等功能于一体的疫情防控数字化管理平台，接入卫健、公安、疾控等市级部门现有指挥系统，贯通国家、省、市、街道、社区五级指挥系统，打造全市疫情防控总指挥中心；推进“互联网+食品药品安全”监管，建立基于大数据分析的食品药品安全信息平台。<br><br>助力数字经济蓬勃发展  营造双向赋能新优势<br><br>《规划》提出，“十四五”期间，成都将围绕加快培育数据要素市场，促进数字产业化和产业数字化，加强数字技术创新应用和完善数字经济创新生态等重点任务，推动智慧蓉城建设与数字经济发展双向赋能，构建形成互促互进、良性循环态势。加快培育数据要素市场，“十四五”期间，成都将建立完善公共数据资源运营机制，推进公共数据资源授权运营，加强政企数据流通通道建设，推动公共数据运营管理全程透明化、可记录、可审计、可追溯，促进数据流通增值；探索数据要素市场化配置综合改革，创新数据要素流通制度机制，促进数据要素流通安全合规有序、配置高效公平、价值活力显现。同时，运用联邦学习、多方安全计算等隐私计算技术，构建产品化、模型化、“可用不可见”服务能力，探索公共数据、科学数据、社会数据融合创新应用。<br><br>以智慧蓉城建设赋能数字经济发展，“十四五”期间，成都将推进国家数字经济创新发展试验区、国家新一代人工智能创新发展试验区建设与智慧蓉城建设深度融合，聚焦智能基础设施、运行管理平台、智慧化应用场景等智慧蓉城建设项目需求，面向国内外企业定期发布更新城市机会清单；推动工业数字化，加快工业领域数字化智能化绿色化融合发展，培育工业互联网应用新模式，发展智能制造，实施企业“上云用数赋智”行动，创建国家数字化转型促进中心，加速家具制造、食品加工等传统产业数字化转型，打造数字化制造“灯塔工厂”和“成都智造”品牌。以数字经济发展赋能智慧蓉城建设，成都还将聚焦产业技术变革及数字化、融合化发展，前瞻布局量子计算、量子通信、神经芯片、DNA存储等技术，聚力攻克光刻机、高端工业软件等关键核心技术，超前研发太赫兹通信等前沿技术，加快智慧蓉城建设相关产品研发突破。<br><br>成都汉康信息产业有限公司始创于2001年，是一家致力于新型智慧城市建设服务的高新技术企业。专注于智慧水务、智慧交通、软件开发及物联网等领域业务，业务范围涵盖前期咨询、方案设计、软件开发、系统集成和应用服务等各环节。<br><br>成都汉康多年来在智慧城市建设服务中取得了卓越的成就。公司取得了15项发明专利、16项实用新型专利、78项软件著作权、2项软件产品登记，自主研发的“基于物联网与灾害数据云的地质灾害监测预警系统”获得了成都市科技进步二等奖、“水文地质及桥隧工程监测预警信息平台关键技术及应用”获得了重庆市科技进步二等奖。<br><br>目前正发展成为国内领先的智慧水务、智慧交通、物联网应用和互联网服务领域优秀企业，参与了一项国家标准制定、一项行业标准制定、三项地方标准制定。获得“国家级守合同重信用企业”、“国家级高新技术企业”、“四川省企业技术中心”、“成都市企业技术中心”等荣誉称号。公司拥有完备的资质，拥有电子与智能化工程专业承包一级、测绘资质乙级、安防工程企业设计施工维护能力一级等资质、CMMI软件成熟度3级、信息技术服务运行维护标准符合性证书贰级(ITSS)、水文水资源调查评价乙级，通过了ISO9001质量管理体系认证、ISO14001环境管理体系认证、ISO45001职业健康安全管理体系认证、ISO27001信息安全管理体系认证、ISO20000信息技术服务管理体系认证、信用等级AAA证书等。",
          time: "06-20",
          yers: "2022",
          imgs: [
            { src: require("../../../assets/imgs/xinwen/12.png") },
            { src: require("../../../assets/imgs/xinwen/12-1.png") },
          ],
        },
        {
          src: require("../../../assets/imgs/xinwen/11-1.png"),
          title: "喜讯：热烈祝贺成都汉康中标成都市锦江区智慧水务项目",
          text: "热烈祝贺成都汉康中标成都市锦江区综合行政执法局智慧水务建设项目，本项目是在智慧水务作为智慧蓉城（6+8+N）“8”大领域应用场景体系中的重要板块建设背景下，成都市水务局下发《关于全域推进智慧水务建设》的通知要求后，首个区（市）县级智慧水务建设项目，是实现超大城市治理体系和治理能力现代化的有机构成。</br></br>通过夯实基础、融同连接、挖掘数据、加强感知、促进应用，搭建锦江区智慧水务总体架构，建设“一大脑、一张图、N 应用、一体系”，强化防汛减灾、河湖管理、水务工程建设、水土保持监管等难点问题，建成全域感知、动态监测、实时预警、协同管理和高效应用的智慧水务平台，构建“预报、预警、预演、预案”四预体系，达到监测、预警、调度和辅助决策全过程，有效支撑锦江区水务业务管理科学化精细化。</br></br>成都汉康信息产业有限公司始创于2001年，是一家致力于新型智慧城市建设服务的高新技术企业。专注于智慧水务、智慧交通、软件开发及物联网等领域业务，业务范围涵盖前期咨询、方案设计、软件开发、系统集成和应用服务等各环节。</br></br>成都汉康多年来在智慧城市建设服务中取得了卓越的成就。公司取得了15项发明专利、16项实用新型专利、78项软件著作权、2项软件产品登记，自主研发的“基于物联网与灾害数据云的地质灾害监测预警系统”获得了成都市科技进步二等奖、“水文地质及桥隧工程监测预警信息平台关键技术及应用”获得了重庆市科技进步二等奖。</br></br>目前正发展成为国内领先的智慧水务、智慧交通、物联网应用和互联网服务领域优秀企业，参与了一项国家标准制定、一项行业标准制定、三项地方标准制定。获得“国家级守合同重信用企业”、“国家级高新技术企业”、“四川省企业技术中心”、“成都市企业技术中心”等荣誉称号。公司拥有完备的资质，拥有电子与智能化工程专业承包一级、测绘资质乙级、安防工程企业设计施工维护能力一级等资质、CMMI软件成熟度3级、信息技术服务运行维护标准符合性证书贰级(ITSS)、水文水资源调查评价乙级，通过了ISO9001质量管理体系认证、ISO14001环境管理体系认证、ISO45001职业健康安全管理体系认证、ISO27001信息安全管理体系认证、ISO20000信息技术服务管理体系认证、信用等级AAA证书等。",
          time: "07-28",
          yers: "2022",
          imgs: [
            { src: require("../../../assets/imgs/xinwen/11.png") },
            { src: require("../../../assets/imgs/xinwen/11-1.png") },
          ],
        },
        // {
        //   src: require("../../../assets/imgs/xinwen/9.jpg"),
        //   title:
        //     "【代表谈盛会】柴军代表 民革省直代表热议民革四川省第十三次代表大会",
        //   text: "2022年4月18日，民革四川省第十三次代表大会胜利闭幕。参加大会的省直工委代表对欧阳泽华主委所做的工作报告展开了持续学习讨论，大家纷纷发表己见，形成了第二批感想。<br><br>民革四川省直工委企业家联谊会执行会长、汉康信息技术集团有限公司董事长<br><br>柴军：<br><br>有幸以代表身份参加了中国国民党革命委员会四川省第十三次代表大会，认真聆听了欧阳泽华主委代表省委会所做的工作报告，感触颇多。<br><br>首先，过去五年以党员身份亲身见证了欧阳泽华主委带领四川民革全体党员在民革中央和中共四川省委的坚强领导下，“守正创新，厚积薄发”做了很多实事，收获了丰硕成果，我由衷地敬佩。<br><br>其次，在参加大会的过程中，我在思想上受到了一次深刻的洗礼。尤其是对民革事业产生了发自肺腑的热爱，从被动转为主动；从内心深处升腾起对民革组织的敬意和依赖，更加坚定了为四川民革事业努力奉献的信心和意志。<br><br>再次，在聆听完欧阳泽华主委的工作报告后，我对四川民革事业发展的未来充满了信心。工作报告内容详实、覆盖面广，尤其是重点讲到要发挥好民革企业家联谊会服务社会的平台作用，我倍受鼓舞。<br><br>作为民革四川省直工委企业家联谊会领导班子成员，我一定谨记欧阳泽华主委的要求，充分发挥企业家联谊会平台优势，深入践行服务社会的愿景，未来将携手企业家联谊会的党员企业家们全力以赴，做好以下几点工作：一是深入开展党地结对帮扶工作，助力乡村振兴；二是充分发挥民革社会法制优势，开展法律援助；三是全力推动在川台企联系交流，加强祖统工作；四是持续培育志愿服务团队能力，参与应急救援；五是大力支持民革特色文化活动，弘扬中山精神",
        //   time: "2-22",
        //   yers: "2021",
        //   imgs: [{ src: require("../../../assets/imgs/xinwen/9.jpg") }],
        // },

        // {
        //   src: require("../../../assets/imgs/xinwen/10.jpg"),
        //   title: "人物专访 | 柴军：心怀责任，向光而行",
        //   text: "2020年10月22日，在甘洛县斯觉镇久违的晴天里，孩子们抱着“梦想大礼包“的笑声正轻轻叩响着每一个人的心扉，阳光下那一张张稚嫩的笑脸更是映在了柴军的记忆里。<br>心怀责任，向光而行。一个人，一个企业，可以为这个社会做些什么？每位善行者各有答案，而“梦想大礼包”捐赠方之一川大校友柴军，正在用他的行动给予回答。<br>2001年，汉康信息产业有限公司（以下简称“汉康公司”）在成都创立。在柴军的带领下，汉康公司现已成为中国领先的智慧水务、地质灾害、智慧城市等领域解决方案与技术服务提供商，并在多项公益事业中贡献力量。<br>其中，“梦想大礼包”即为柴军以四川大学知名校友的身份，参与由四川大学教育基金会与四川大学校友总会联合开办的公益项目——“为梦想奔跑——甘洛儿童素质教育资助计划”（“校友线上跑”的子项目）。该活动于四川大学124周年校庆之际开办，共募集善款219753.3元，为甘洛县12岁以下的1600余名孩子们提供美术、音乐、体育类学习用品，帮助孩子们实现走出大山的第一步。倡议一经提出，柴军便通过四川大学教育基金会老师的介绍，快速投入到该项目的募集中。柴军始终将社会责任践行放在企业发展战略中的重要位置，让社会价值与企业发展同步。这是一颗顽强拼搏的赤子之心，这是一场聚沙成塔的温暖之旅，这是一条企业家的社会责任践行之路。<br><br>创业：社会与个人并重<br><br>1998年，柴军从大学毕业，这之后他分别前往了一家澳洲外资企业、智邦大陆科技股份有限公司与上海罗顿发展股份有限公司。三年的经历让他学习到了企业家们是如何用人管理与运营公司的，也让他萌发出绘制一幅属于自己的事业蓝图的梦想。<br>创业初期，柴军的网络产品代理项目并不顺利，不仅收益较少，且时常需要受制于人。在开始自主研发之后，他选择聚焦地质（山洪）方向，基于GIS地理信息系统应用进行软件开发，但仍然面临获客困难、资金不足、持续亏损种种问题。“有多次想要放弃的念头，”柴军说，“但你的情理之中想成为什么样的人，他能给你带来的执着、目标、信念、不到南墙不回头的想法，很重要。”就是这样一种信念，让柴军不顾一切去实现自己热爱的事业。<br>就在2008年，一切迎来了转机。“5.12汶川大地震”让所有人意识到灾害预警系统的重要性，柴军则顺应这一机遇，接连中标多地的灾害预警系统工程，推动公司走上高速发展期。<br>“当我们做的事不仅有经济收益，还产生了社会效益的时候，内心是真的很满意。”柴军先生这样评价自己的事业。2010年，汉康公司在四川省绵竹市设立的灾后重建山洪灾害预警系统发挥重大作用，提前成功预警，保护了5400人生命财产安全。<br>同时，川大的求学经历也让柴军意识到不断学习的重要性，他深知再学习的能力是未来一个人能不能成功，或能不能在某个领域做出成绩的重要因素。彼时，国家城市发展战略引起了他的注意，为了进一步升级本公司产业，他依托自身高科技，打造新型智慧城市与公共安全一体化，在地质灾害预警的基础上，拓展智慧城市建设板块，实现了创新。<br>如今，个人的雄心与对社会的责任心，让柴军仍然在数字经济信息化产业领域不断耕耘，他希望能够通过自己的努力，使公司形成产业化运作，成为上市公司，同时致力于推动智慧水务、公共安全监测预警和新型智慧城市等技术的革新，让企业发挥更大的社会效益。<br><br>公益：责任与事业同行<br><br>二十世纪七八十年代，在柴军的家乡，安徽省六安市，年轻人想要出人头地只有两种方式，当兵或者考大学。柴军选择了后者。日后，教育亦成为汉康公司公益事业的关注重点之一。“教育是无论家庭、企业、国家或一切的希望，人是最重要的，教育是排名第一的。“柴军说。<br>从2011年开始，连续四年的时间里，柴军个人共资助3~5位贫困大学生，帮助他们顺利完成学业，走向了更加光明的未来。曾经一位安徽的女生差点因无力负担学费而放弃上大学，柴军的善举则让她走出了大山的困境。如今，大学毕业的她不再需要和父辈一样面朝黄土背朝天，能够在北京过上了更好的生活，也彻底地改变了家族的命运。给孩子最好的礼物便是教育。读书改变了柴军的人生，他坚信“知识改变命运”。现在，他期待能够通过自己的努力让更多孩子有机会去奔赴更美好的明天。<br>公益之路没有重点。柴军希望，随着公司规模的扩大，能够建立帮扶基金会，着力教育方向，为贫困学生或意欲创业的大学生们提供资金支持，助力学子们实现梦想。<br>对于企业来说，创造商业利益是永恒的目标，但公益事业始终是柴军心里一颗不可磨灭的火种。他的想法很朴实，“多做点善事，帮助一些能帮助的人”。<br>早在2008年，正值汉康公司的发展瓶颈期，柴军就缩减公司支出捐出善款，用于支援“5.12汶川大地震”抢险救灾工作。柴军说：“看到了很多悲惨的事情，挤一些钱也愿意帮助该帮助的人。”<br>此外，汉康公司积极响应政府号召，在2017年加入“万企帮万村”精准扶贫活动，对口支援四川省凉山州特布洛乡吉子纳乌村与竹核乡瓦托村，充分发挥企业自身人才、技术、资金等优势，帮助贫困地区增收，带动贫困人口脱贫。<br>去年新冠肺炎疫情爆发期间，他也带领汉康公司捐献善款与必需品支援前线，甚至还两次冒着感染的危险，亲自为医护人员运送医疗物资。<br>柴军坚持“取之社会，用之社会”的公益理念，“不想着回报，也不图回报”，帮助真正需要帮助的人们，推动解决实际困难与问题，积极履行企业社会责任。<br>二十多年来，柴军用实际行动践行着自己的创业初心，执着于数字经济信息化产业领域，满怀激情不断创新，更是迸发出强大的社会价值创造力。同时，他坚守着自己的恒心，真正用手、用心、用情感来践行着社会责任，心怀责任担当与使命感，推进企业的公益事业。未来，相信在更多像柴军一样的企业家带动下，社会将更加美好。",
        //   time: "2-22",
        //   yers: "2021",
        //   imgs: [
        //     { src: require("../../../assets/imgs/xinwen/10.jpg") },
        //     { src: require("../../../assets/imgs/xinwen/10-1.jpg") },
        //     { src: require("../../../assets/imgs/xinwen/10-2.jpg") },
        //   ],
        // },

        // {
        //   src: require("../../../assets/imgs/xinwen/1.png"),
        //   title: "2021年董事长新年贺词",
        //   text: " 2020年，是极不平凡的一年，突入奇来的新冠疫情袭卷全球，迫使我们每个人都经历防控抗疫的特殊考验。如今的成都街头，处处洋溢着节日的气氛，每个人心里都有些别样的感动！迎接着充满希望、孕育生机的2021年！</br>&nbsp; &nbsp; &nbsp; &nbsp; 回顾2020年，汉康人上半场主旋律是捐款捐物抗击疫情、休养生息、完善公司治理、加大软件研发；汉康人下半场主旋律是厚积勃发、逆势飞扬！在激烈的市场竞争中，成功中标一个又一个重点项目，年终收官，获得骄人业绩！</br>&nbsp; &nbsp; &nbsp; &nbsp; 经典事件：</br>&nbsp; &nbsp; &nbsp; &nbsp;1、 中标成都市智慧交通空间地理信息基础支撑及服务系统建设一张图项目，成为未来大成都智慧交通大脑空间地理信息基础支撑平台,</br>&nbsp; &nbsp; &nbsp; &nbsp;2、 中标成都市基层防汛监测预警体系-智能预警平台项目，成为未来大成都城区暴雨内涝监测预警预报、流域洪水实时预报预警智能预警支撑平台，</br>&nbsp; &nbsp; &nbsp; &nbsp;3、 中标成都龙泉国家级经济开发区智慧水务项目，成为大成都首个饮水安全大数据管理平台，是贯彻《健康中国－优水计划》规划的首个落地案例，</br>&nbsp; &nbsp; &nbsp; &nbsp;4、 直饮水大数据平台项目正式立项启动，为首期100万用户目标居民提供饮水安全线上运营服务，</br>&nbsp; &nbsp; &nbsp; &nbsp;5、 参加第十四届中国智慧城市大会，并做《智慧城市操作系统支撑应用》主题演讲…展望2021年，又是一个创造梦想、扬帆起航的关键之年，我们将把握机遇、求真务实、锐意进取、大胆创新、迎难而上，共创2021年事业新的辉煌。</br></br></br>&nbsp; &nbsp; &nbsp; &nbsp;在这牛年即将到来之际，我谨通过汉康微信平台向广大客户、社会各界朋友、股东、员工表示衷心感谢！给大家拜年啦 ！</br>&nbsp; &nbsp; &nbsp; &nbsp;祝您在新的一年里，身体健康、心想事成、幸福快乐！",
        //   time: "2-22",
        //   yers: "2021",
        //   imgs: [{ src: require("../../../assets/imgs/xinwen/1.png") }],
        // },
        {
          src: require("../../../assets/imgs/xinwen/2 (1).png"),
          title: "热烈祝贺成都汉康成立二十周年",
          text: "2021年5月8日，对于汉康人是一个隆重的日子，在热情雄壮的《汉康之歌》中开启“乘风破浪、御势而行”为主题的成都汉康二十周年庆典活动。</br></br>20年峥嵘岁月，有欢声笑语，也有痛苦流泪，“5∙12”成都汉康利用自主专利技术建立的绵竹山洪灾害监测预警系统，在2010年8月13日成功预警，实现5400人安全转移，创造了“绵竹大转移”奇迹，开启了汉康走向全国发展之路。2015年成功中标霍山智慧城市建设项目让汉康走进了中国信息化建设更高阶的大门，从另一个角度参与到城市智慧化建设中。20年前成都汉康从代理产品的初创公司，开展自主研发、系统集成，逐步成为智慧城市解决方案与技术服务提供商，以投资、建设、运营的模式参与到城市基础设施、城市大脑、智慧政务、智慧水务、智慧交通等等领域中，为社会贡献汉康智慧，汉康力量。</br></br>回首过往，皆是序章，未来的日子我们不忘初心，开拓创新，我们希望与伙伴们继续携手同行。柴总对公司过去20年进行总结以及对未来进行憧憬。",
          time: "5-11",
          yers: "2021",
          imgs: [
            { src: require("../../../assets/imgs/xinwen/2 (1).png") },
            { src: require("../../../assets/imgs/xinwen/2 (2).jpg") },
            { src: require("../../../assets/imgs/xinwen/2 (3).jpg") },
            { src: require("../../../assets/imgs/xinwen/2 (4).jpg") },
            { src: require("../../../assets/imgs/xinwen/2 (5).jpg") },
            { src: require("../../../assets/imgs/xinwen/2 (6).jpg") },
            { src: require("../../../assets/imgs/xinwen/2 (7).jpg") },
            { src: require("../../../assets/imgs/xinwen/2 (8).jpg") },
            { src: require("../../../assets/imgs/xinwen/2 (9).jpg") },
            { src: require("../../../assets/imgs/xinwen/2 (10).jpg") },
          ],
        },
        // {
        //   src: require("../../../assets/imgs/xinwen/3.jpg"),
        //   title: "热烈祝贺自贡市智慧城市国有平台公司与达成战略合作",
        //   text: "3月18日自贡市智慧城市网络科技有限责任公司董事长李冰一行到汉康信息技术集团有限公司参观交流！双方在智慧城市、数字经济领域达成了长效机制合作的共识，签署战略合作协议，利用双方优势，共同推进自贡市智慧城市建设，尤其在擅长的智慧水务、智慧交通、智慧政务、智慧园区等领域！",
        //   time: "4-22",
        //   yers: "2021",
        //   imgs: [{ src: require("../../../assets/imgs/xinwen/3.jpg") }],
        // },
        // {
        //   src: require("../../../assets/imgs/xinwen/4.jpg"),
        //   title: "喜讯：川力汉康直饮水大数据平台正式签约投资",
        //   text: "2021年 1月13日上午，川力股份与成都汉康投资直饮水大数据平台项目正式签约，标志着直饮水大数据在线平台项目正式启动，首期为100万户目标居民提供线上运营服务，解决中国居民饮用水安全问题，践行健康中国、优水计划国策</br></br>本次合作，双方共同投资成立直饮水大数据运营有限公司，针对直饮水市场进行投资、建设和运营。</br></br>参加签约仪式的人员有川力股份公司董事长闵汝贤、副总裁张伟、秦东、李明成、石阿玲；汉康信息董事长柴军、副总裁朱正修、王晓博、冯丽。",
        //   time: "4-22",
        //   yers: "2021",
        //   imgs: [
        //     { src: require("../../../assets/imgs/xinwen/4.jpg") },
        //     // { src: require("../../../assets/imgs/xinwen/4-1.jpg") },
        //     // { src: require("../../../assets/imgs/xinwen/4-2.jpg") },
        //   ],
        // },
        {
          src: require("../../../assets/imgs/xinwen/5.png"),
          title: "热烈祝贺成都汉康再次中标2000万级成都市智慧水务项目",
          text: "热烈祝贺成都汉康中标成都基层防汛监测预警体系-智能预警平台项目。</br></br>本项目利用汉康先进的软件技术，构建成都市山洪灾害监测预警平台、防汛智能监测网络和预警平台、中心城区暴雨内涝预警模型、一二维耦合水动力模型等，实现中心城区暴雨内涝监测及预报预警，实时洪水预警预报和风险分析；实现流域洪水实时预报预警和风险动态分析展示，为城市精细化洪水调度管理、决策支持奠础。",
          time: "4-22",
          yers: "2021",
          imgs: [
            { src: require("../../../assets/imgs/xinwen/5.png") },
            { src: require("../../../assets/imgs/xinwen/5-1.png") },
            { src: require("../../../assets/imgs/xinwen/5-2.png") },
          ],
        },
        // {
        //   src: require("../../../assets/imgs/xinwen/6.jpg"),
        //   title: "热烈祝贺柴军先生荣获“2020智慧城市行业精英”殊荣，并做主题演讲",
        //   text: "11月26日，第十四届中国智慧城市大会在北京国际会议中心隆重召开。董事长柴军先生受邀参加本次大会。</br></br>中国智慧城市大会是我国智慧城市领域的重要平台，致力于贯彻落实中央新型智慧城市战略指导政策，宣传推介我国智慧城市建设优秀案例与成果，加强国内智慧城市建设交流合作，其中智慧城市行业精英是对从事智慧城市实践、研究、教学工作，对智慧城市技术革新、行业发展、社会效益做出突出贡献的专业人士的评选。柴军先生获得这一殊荣，也充分说明了行业人士对于他近年来在我国智慧城市领域所做的相关实践、研究等方面工作的高度认可。</br></br>柴军先生做《智慧城市操作系统支撑应用》主题演讲，汉康智慧城市操作系统基于GIS+BIM为基础，建立标准管理体系和安全管理体系，对计算、存储、网络、数据等资源集群高效管理，架设物联网总线和服务总线提供全类别数据集成、全要素表达、融合数据分析及预测能力、实时可视化控制能力、城市动态更新能力。",
        //   time: "4-22",
        //   yers: "2021",
        //   imgs: [
        //     { src: require("../../../assets/imgs/xinwen/6.jpg") },
        //     { src: require("../../../assets/imgs/xinwen/6-1.jpg") },
        //     { src: require("../../../assets/imgs/xinwen/6-2.jpg") },
        //   ],
        // },
        {
          src: require("../../../assets/imgs/xinwen/7.jpg"),
          title: "中标资讯： 热烈祝贺成都汉康中标1000万级小型水库监测预警项目",
          text: "热烈祝贺成都汉康中标安徽省六安市裕安区1000万级小型水库雨水情自动测报系统建设项目。</br></br>本项目位于安徽省六安市裕安区境内，小型水库大多位于偏僻位置且交通不便，安全隐患大、管理人员少。本项目采用信息技术，实现对各小型水库雨水情信息的自动采集、传输、分析和呈现，实现对全区范围内水库雨情、水情、水位进行实时在线监测预警，与省市县互联互通、信息共享，实现小型水库雨水情测报全覆盖，落实水库防汛“信息精准、指挥精准、措施精准”目标要求，为水库防汛指挥调度、预报预警提供信息保障。",
          time: "4-22",
          yers: "2021",
          imgs: [{ src: require("../../../assets/imgs/xinwen/7.jpg") }],
        },
        {
          src: require("../../../assets/imgs/xinwen/8.jpg"),
          title: "中标资讯：成都汉康携手阿里云斩获3000万级软件大单",
          text: "热烈祝贺成都汉康携手阿里云，中标成都市智慧交通空间地理信息基础支撑及服务系统建设一张图项目。</br></br>本项目由成都交通投资集团投资，采用汉康GIS+BIM大数据技术和高德地图路网数据，为成都市智慧交通数据中心平台、交通运输行业应用平台提供标准的、全面的、权威的空间地理信息基础资源服务，打造成都市智慧交通规划建设一张图，打通城市交通数据神经系统和城市交通疏导系统，提供公共出行调度系统、智能引擎规划系统和无人驾驶高精地图服务。成为未来智慧交通大脑空间地理信息基础支撑平台。</br></br>业主简介：成都交通投资集团是成都市政府独资市级交通基础设施投融资的大型国有综合交通企业集团，主要承担成都市交通基础设施项目的投融资、开发建设和经营管理工作。目前，成都交投集团按照“功能化、专业化、市场化、国际化”的发展要求已形成了公路、铁路、航空三大核心产业，实业开发、运业物流、智慧停车、智能交通四大交通配套业务的3+4产业布局，按照主业突出、专业分工、协同发展的原则改组形成集团总部、12家二级子集团、60余家三级子公司的管理体系，员工6000余人，已经成为中西部综合交通领军企业集团。",
          time: "4-22",
          yers: "2021",
          imgs: [
            { src: require("../../../assets/imgs/xinwen/8.jpg") },
            { src: require("../../../assets/imgs/xinwen/8-1.jpg") },
          ],
        },
      ],
      btn: [
        { name: "展开更多", class: "el-icon-bottom", show: true },
        { name: "收起更多", class: "el-icon-top", show: false },
      ],
      btnShow: true,
      arr: [],
      bg: null,
      boxarr: [],

      nav: [
        { name: "公司新闻", type: 0, activebool: false },
        { name: "其他新闻", type: 1, activebool: false },
      ],
    };
  },
  created() {
    this.arr = JSON.parse(JSON.stringify(this.list));
    this.arr = this.arr.splice(0, 6);
  },
  methods: {
    more(v) {
      //  console.log("v :>> ", v);
      this.$router.push({ name: "two", params: v });
      window.sessionStorage.setItem("xinwen", JSON.stringify(v));
    },
    active() {
      this.btnShow = !this.btnShow;
      if (this.btnShow) {
        this.arr = this.arr.splice(0, 6);
      } else {
        this.arr = JSON.parse(JSON.stringify(this.list));
      }
    },
    scroll() {
      let scroll =
        document.body.scrollTop || document.documentElement.scrollTop;
      this.boxarr.push(scroll);
      //  console.log("scroll :>> ", scroll);
      if (this.boxarr.length > 2) {
        let a = [this.boxarr[this.boxarr.length - 1]];
        let b = [this.boxarr[this.boxarr.length - 2]];

        if (a - b >= 0) {
          // console.log("往下滑");
          //控制导航条

          this.$refs.header.style.position = "absolute";
          this.$refs.header.style.top = "0";
          this.$refs.header.style.left = "0";
          this.$refs.header.style.zIndex = "100";
        } else {
          // console.log("往上滑");
          if (scroll > 300) {
            this.$refs.header.style.position = "fixed";
            this.$refs.header.style.top = "0";
            this.$refs.header.style.left = "0";
            this.$refs.header.style.zIndex = "100";
            this.bg = "black";
          }
        }
      }
      if (scroll <= 280) {
        this.$refs.header.style.position = "absolute";
        this.$refs.header.style.top = "0";
        this.$refs.header.style.left = "0";
        this.$refs.header.style.zIndex = "100";
      }
    },
  },
  mounted() {
    document.body.scrollTop = 0;

    window.addEventListener("scroll", this.scroll, true);
  },
  beforeDestroy() {
    // this.time=null
    window.removeEventListener("scroll", this.scroll, true);
  },
};
</script>

<style lang="scss" scoped>
.one {
  width: 100%;
  height: 100%;
  background-color: #fff;

  .toubu {
    width: 1920px;
    height: 500px;
    background-image: url("../../../assets/imgs/xinwen/bg22.png");
    background-size: 100% 100%;
    margin: 0 auto;
    position: relative;

    .text {
      // min-width: 462px;
      position: absolute;
      top: 180px;
      left: 343px;
      font-size: 60px;
      font-family: Alibaba PuHuiTi;
      font-weight: 700;
      line-height: 84px;
      color: #ffffff;
      // border-bottom: 1px solid rgba(75, 75, 75, 1);
      // padding-bottom: 20px;
      .bottom {
        font-size: 20px;
        font-family: Alibaba PuHuiTi Xi !important;
        font-weight: normal;
        line-height: 22px;
        color: #ffffff;
        margin-top: 8px;
      }
    }
  }
  .nav-box {
    width: 100%;
    height: 52px;

    position: absolute;
    left: 0;
    top: 478px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    .nav {
      height: 52px;
      background: rgba(255, 255, 255, 1);

      display: flex;
      // position: absolute;
      // left: 390px;
      // top: 478px;

      .nav-son {
        width: 380px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Alibaba PuHuiTi Xi !important;
        font-weight: normal;
        color: #888888;
        opacity: 1;
        cursor: pointer;
      }
      .nav-son:hover {
        color: #1664ff;
      }
      .nav-active {
        background-color: #1664ff;
        color: #fff !important;
      }
    }
  }
  .box {
    width: 1920px;
    margin: 0 auto;
    padding: 80px 260px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .son {
      width: 656px;
      height: 520px;
      // background: rgba(170, 170, 170, 0.39);
      opacity: 1;
      position: relative;
      cursor: pointer;
      .img {
        width: 100%;
        height: 338px;
      }
      .title {
        margin-top: 20px;
        font-size: 20px;
        font-family: Alibaba PuHuiTi Xi !important;
        font-weight: 400;
        color: #333333;
        span {
          font-weight: 700;
        }
      }
      .text {
        height: 20px;
        margin-top: 18px;
        font-size: 14px;
        font-family: Alibaba PuHuiTi Xi !important;
        font-weight: 300;
        overflow: hidden;
        color: #888888;
        opacity: 1;
      }
      .time {
        margin-top: 46px;
        font-size: 20px;
        font-family: Alibaba PuHuiTi Xi !important;
        font-weight: 400;

        color: #c8c8c8;
        opacity: 1;
        span {
          font-size: 14px;
          font-family: Alibaba PuHuiTi Xi !important;
          font-weight: 400;

          color: #c8c8c8;
          opacity: 1;
        }
      }
      em {
        position: absolute;
        left: 0;
        bottom: 70px;
        width: 100%;
        height: 1px;
        background-color: #ebebeb;
        .line {
          width: 0;
          height: 100%;
          background-color: black;
          transition: all 0.6s linear;
        }
      }
      .jiantou {
        position: absolute;
        bottom: 24px;
        right: 40px;
        font-size: 18px;
        font-family: Alibaba PuHuiTi Xi !important;
        font-weight: 700;

        color: #c8c8c8;
        opacity: 1;
      }
    }
    .son:hover .title {
      color: #3067ff;
    }
    .son:hover .line {
      width: 100%;
    }
    .gengduo_box{
      width: 100%;

      .gengduo {
        padding: 0 20px;
        width: 128px;
        height: 44px;
        border: 1px solid #d8d8d8;
        opacity: 1;
        margin: 0 auto;
        font-size: 12px;
        font-family: Alibaba PuHuiTi Xi !important;
        font-weight: 400;
        color: #888888;
        display: flex;
        align-items: center;
        justify-content: space-around;
        cursor: pointer;
      }
    }
  }
}
</style>
